import './style.scss'
import { message, Modal } from 'antd'
import React, { Suspense, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LogoTitleEn from '@/assets/logo-title-en.png'
import LogoTitle from '@/assets/logo-title.webp'
import Logo from '@/assets/logo.webp'
import { isZh } from '@/libs/util'
import MobieLogin from '@/views/login/components/mobie-login'
import { LoginStore } from '@/views/login/states'

interface IProps {
  open: boolean
  onCancel?: () => void
}

const LoginModal: React.FC<IProps> = (props) => {
  const { open, onCancel } = props
  const { t: translate } = useTranslation(['system'])

  useEffect(() => {
    if (open) {
      LoginStore.loginType = 1
    }
  }, [open])

  const onLoginSuccess = async () => {
    message.success(translate('system.login_success'))
    onCancel?.()
  }

  return (
    <Suspense>
      <Modal zIndex={2002} className="login-modal" width={500} open={open} onCancel={onCancel} footer={null}>
        <div className="login-top">
          <img className="logo" src={Logo} />
          {isZh() ? (
            <img className="logo-title" src={LogoTitle} />
          ) : (
            <img className="logo-title-en" src={LogoTitleEn} />
          )}
        </div>
        <MobieLogin onLoginSuccess={onLoginSuccess} />
      </Modal>
    </Suspense>
  )
}

export default LoginModal
